/**
 * iter45 — Extracted from LeagueDashboard.jsx.
 *
 * Dismissible banner that nudges participants to add a recovery email if
 * they don't have one saved. Persists dismiss state in localStorage so
 * it stops showing across sessions until/unless they actually add one.
 */
import { Mail, X } from "lucide-react";

export default function EmailRecoveryBanner({ onOpenAddEmail, onDismiss }) {
    return (
        <div
            className="brutal-card-light p-4 flex flex-wrap items-center justify-between gap-3"
            data-testid="email-recovery-banner"
        >
            <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="w-8 h-8 bg-cyber border-2 border-black shadow-brutal flex items-center justify-center shrink-0">
                    <Mail className="w-4 h-4 text-black" strokeWidth={2.5} />
                </div>
                <div className="min-w-0">
                    <p className="font-bold text-sm">Add a recovery email</p>
                    <p className="text-xs text-zinc-400">
                        If you ever forget your username, we'll send you a magic link to get back in.
                    </p>
                </div>
            </div>
            <div className="flex gap-2">
                <button
                    data-testid="open-add-email-btn"
                    onClick={onOpenAddEmail}
                    className="brutal-btn-secondary text-xs py-2"
                >
                    Add email
                </button>
                <button
                    onClick={onDismiss}
                    className="brutal-btn-ghost p-2"
                    aria-label="Dismiss"
                    data-testid="dismiss-email-banner-btn"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
